import { Drawer, DrawerClose } from '@salecycle/ui-component-library';
import { useDrawer } from '../../state/actions/useDrawer';
import { CampaignDrawerFooter } from './CampaignDrawerFooter';
import { CampaignDrawerBody } from './CampaignDrawerBody';

export const CampaignDrawer = () => {
  const [open, setOpen] = useDrawer();

  return (
    <Drawer open={open} onClose={() => setOpen(false)} fullScreen direction="right" footer={<CampaignDrawerFooter />}>
      <DrawerClose onClose={() => setOpen(false)} />
      <CampaignDrawerBody />
    </Drawer>
  );
};
